
import useSoknader from "../hooks/useSoknader";
import {createContext} from "react";
import {SoknadClass} from "../models/SoknadClass";
import {getVedlegg} from "../service/soknaderService";

const defaultValue:any={};
const SoknaderContext=createContext(defaultValue);
function SoknaderProvider({children}:any){
    const{
        soknader,
        soknaderIsLoading,
        user,
        userInformation,
        getSoknadById,
        updateSoknad,
        soknad,
        setSoknad,
        employmentTypes,
        poststed,
        fylker,
        soknadVedlegg,
        getVedlegg,
        godkjenteKurs,
        downloadFileFunction,
        soknadNotes,
        createNoteFunction,
        handleFileChange,
        file,
        setFile,
        handleUpload,
        deleteVedlegg,
        setSoknader,
        loadingNotes,
        loadingVedlegg,
        hentInfoFraCrm,
        trekkSoknad,
        errors
    }=useSoknader();

    return (
        <SoknaderContext.Provider value={{
            soknader,
            user,
            userInformation,
            soknaderIsLoading,
            getSoknadById,
            updateSoknad,
            soknad,
            setSoknad,
            employmentTypes,
            poststed,
            fylker,
            soknadVedlegg,
            getVedlegg,
            godkjenteKurs,
            downloadFileFunction,
            soknadNotes,
            createNoteFunction,
            handleFileChange,
            file,
            setFile,
            handleUpload,
            deleteVedlegg,
            setSoknader,
            loadingNotes,
            loadingVedlegg,
            hentInfoFraCrm,
            trekkSoknad,
            errors
        }}>
            {children}
        </SoknaderContext.Provider>
    )
}

export {SoknaderProvider, SoknaderContext}